<script>
    export let text;
    import {_} from "svelte-i18n";
</script>

{#if text === 'midterm'}
    <div class="element columns">
        <div class="lead column is-one-quarter">
            <strong>{$_('subjectCard.exam')}:</strong>
        </div>
        <div class="text column">
            {$_('midterm')}
        </div>
    </div>
{/if}
{#if text === 'exam'}
    <div class="element columns">
        <div class="lead column is-one-quarter">
            <strong>{$_('subjectCard.exam')}:</strong>
        </div>
        <div class="text column">
            {$_('exam')}
        </div>
    </div>
{/if}